import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import SearchIcon from '@mui/icons-material/Search';
import * as XLSX from 'xlsx';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { IconButton } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';
import RefreshIcon from '@mui/icons-material/Refresh';
import FeedIcon from '@mui/icons-material/Feed';
import Select from 'react-select';
import CopyrightIcon from '@mui/icons-material/Copyright';
import CircularProgress from '@mui/material/CircularProgress';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

function StockTransfer() {
    const [dataBill, setDataBill] = useState([]);
    const [dataItem, setDataItem] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    const tableRef = React.createRef();
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');

    const [itemOptions, setItemOptions] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null);
    const [itemId, setItem] = useState(0);

    const [branchOptions, setBranchOptions] = useState([]);
    const [selectedBranch, setSelectedBranch] = useState(null);
    // const [branchId, setBranch] = useState(0);

    const { isAuthenticated, companyId, branchId, permissions, token, logout } = useAuth();

    const [OrionQty, setOrionQty] = useState(0);
    const [UbcityQty, setUbcityQty] = useState(0);
    const [PMCChennaiQty, setPMCChennaiQty] = useState(0);
    const [PMCBangaloreQty, setPMCBangaloreQty] = useState(0);
    const [HYDForumQty, setHYDForumQty] = useState(0);
    const [InorbitQty, setInorbitQty] = useState(0);
    const [LandTQty, setLandTQty] = useState(0);
    const [VRQty, setVRQty] = useState(0);
    const [ShantiniketanQty, setShantiniketanQty] = useState(0);
    const [HeadOfficeQty, setHeadOfficeQty] = useState(0);


    const [selectedOption, setSelectedOption] = useState('out');

    useEffect(() => {
        let OrionQty = 0;
        let UbcityQty = 0;
        let PMCChennaiQty = 0;
        let PMCBangaloreQty = 0;
        let HYDForumQty = 0;
        let InorbitQty = 0;
        let LandTQty = 0;
        let VRQty = 0;
        let ShantiniketanQty = 0;
        let HeadOfficeQty = 0;

        dataItem.forEach(item => {
            OrionQty += item.OrionQty;
            UbcityQty += item.UbcityQty;
            PMCChennaiQty += item.PMCChennaiQty;
            PMCBangaloreQty += item.PMCBangaloreQty;
            HYDForumQty += item.HYDForumQty;
            InorbitQty += item.InorbitQty;
            LandTQty += item.LandTQty;
            VRQty += item.VRQty;
            ShantiniketanQty += item.ShantiniketanQty;
            HeadOfficeQty += item.HeadOfficeQty;
        });

        setOrionQty(OrionQty);
        setUbcityQty(UbcityQty);
        setPMCChennaiQty(PMCChennaiQty);
        setPMCBangaloreQty(PMCBangaloreQty);
        setHYDForumQty(HYDForumQty);
        setInorbitQty(InorbitQty);
        setLandTQty(LandTQty);
        setVRQty(VRQty);
        setShantiniketanQty(ShantiniketanQty);
        setHeadOfficeQty(HeadOfficeQty);

    }, [dataItem]);

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        setFromDate(getFormattedStartDate());
        setToDate(getFormattedCurrentDate());
        fetchTableData();
        fetchBranchData();
        fetchItemData();
    }, [isAuthenticated, companyId, token, logout]);

    const handleBranchSelect = (selectedOption) => {
        setSelectedBranch(selectedOption);
        const branchId = selectedOption ? selectedOption.value : '';
        setBranch(branchId);
        setDataItem([])
    };

    const handleItemSelect = (selectedOption) => {
        setSelectedItem(selectedOption);
        const itemId = selectedOption ? selectedOption.value : '';
        setItem(itemId);
        setDataItem([])
    };



    const fetchBranchData = () => {
        fetchData('ReportApi', `/Branch/${companyId}/${branchId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                const options = data.map((customer) => ({
                    label: customer.Name,
                    value: customer.Id,
                }));
                setBranchOptions(options);
            })
            .catch((error) => {
                console.error('Error fetching branch data:', error);
            });
    };

    const fetchItemData = () => {
        fetchData('ReportApi', `/Item/${companyId}/${branchId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                const options = data.map((customer) => ({
                    label: customer.Code + '-' + customer.Name,
                    value: customer.Id,
                }));
                setItemOptions(options);
            })
            .catch((error) => {
                console.error('Error fetching branch data:', error);
            });
    };

    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };

    const getFormattedStartDate = () => {
        const monthStartDate = new Date();
        monthStartDate.setDate(1);
        return monthStartDate.toISOString().split('T')[0];
    };

    const handleFromDateChange = (e) => {
        const selectedDate = e.target.value;
        setFromDate(selectedDate);
    };

    const handleToDateChange = (e) => {
        const selectedDate = e.target.value;
        setToDate(selectedDate);
    };

    const hasReadReportPermission = permissions.includes('Read Reports');
    const [loading, setLoading] = useState(false);

    const handleChange = (event) => {
        setSelectedOption(event.target.value);
        setDataItem([])
    };

    const fetchTableData = async () => {
        if (hasReadReportPermission) {
            setDataItem([])
            setLoading(true);
            try {


                if (selectedOption === 'out') {
                    const response = await fetchData('ReportApi', `/StockTransferout/${fromDate}/${toDate}/${companyId}/${branchId}/${itemId}`, token);
                    if (response.responseCode === '1111') {
                        setDataItem(response.response_data);
                    }
                } else if (selectedOption === 'in') {
                    const response = await fetchData('ReportApi', `/StockTransferint/${fromDate}/${toDate}/${companyId}/${branchId}/${itemId}`, token);
                    if (response.responseCode === '1111') {
                        setDataItem(response.response_data);
                    }
                }

            } catch (error) {
                console.error('Error fetching Sales Details:', error);
            }
            finally {
                setLoading(false); // Hide loading screen
            }
        }
    };

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const filteredDataBill = dataBill.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const filteredDataItem = dataItem.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return new Date(dateString).toLocaleDateString('en-GB', options);
    };



    // const handleExportExcel = () => {

    //     const excelData = [];
    //     if (selectedOption === 'out') {
    //         const headerCaption = [`Stock Transfer Out From : ${formatDate(fromDate)} To : ${formatDate(toDate)}`];
    //         excelData.push(headerCaption);
    //     } else if (selectedOption === 'in') {
    //         const headerCaption = [`Stock Transfer In From : ${formatDate(fromDate)} To : ${formatDate(toDate)}`];
    //         excelData.push(headerCaption);
    //     }


    //     const headerRow = ['Code', 'Item', 'Purchase Rate', 'MRP', 'GST%', 'HSN Code', 'PG', 'IG', 'ISG', 'PF', 'Category', 'Group',
    //         'UB City', 'Orion Mall', 'PMC Chennai', 'PMC Bangalore', 'Inorbit Mall', 'L&T Metro Mall', 'VR Mall', 'Hyderabad Forum', 'Shantiniketan', 'Ecomm'
    //     ];
    //     excelData.push(headerRow);
    //     filteredDataItem.forEach((rowData, index) => {
    //         const dataRow = [];
    //         dataRow.push(parseFloat(rowData.Code), rowData.Name, parseFloat(rowData.PurchaseRate.toFixed(2)), parseFloat(rowData.MRP.toFixed(2)), rowData.GSTRate, rowData.HSNCode, rowData.PG, rowData.IG, rowData.ISG, rowData.PF, rowData.CategoryName, rowData.ItemGroupName,
    //             rowData.UbcityQty, rowData.OrionQty, rowData.PMCChennaiQty, rowData.PMCBangaloreQty, rowData.InorbitQty, rowData.LandTQty, rowData.VRQty, rowData.HYDForumQty, rowData.ShantiniketanQty, rowData.HeadOfficeQty
    //         );
    //         excelData.push(dataRow);
    //     });
    //     // Add total row
    //     const totalRow = ['', 'Total', '', '', '', '', '', '', '', '', '', '', UbcityQty, OrionQty, PMCChennaiQty, PMCBangaloreQty, InorbitQty, LandTQty, VRQty, HYDForumQty, ShantiniketanQty, HeadOfficeQty];
    //     excelData.push(totalRow);
    //     const ws = XLSX.utils.aoa_to_sheet(excelData);
    //     const wb = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(wb, ws, 'Stock');
    //     XLSX.writeFile(wb, 'Stock_Transfer.xlsx');
    // };


    const handleExportExcel = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Stock');

        // Caption text based on option
        let headerCaption = '';
        if (selectedOption === 'out') {
            headerCaption = `Stock Transfer Out From : ${formatDate(fromDate)} To : ${formatDate(toDate)}`;
        } else if (selectedOption === 'in') {
            headerCaption = `Stock Transfer In From : ${formatDate(fromDate)} To : ${formatDate(toDate)}`;
        }

        // Merge and style caption row
        worksheet.mergeCells('A1:V1');
        const captionCell = worksheet.getCell('A1');
        captionCell.value = headerCaption;
        captionCell.font = { bold: true, size: 14 };
        captionCell.alignment = { vertical: 'middle', horizontal: 'left' };

        // Header row values
        const headerRowValues = [
            'Code', 'Item', 'Purchase Rate', 'MRP', 'GST%', 'HSN Code', 'PG', 'IG', 'ISG', 'PF', 'Category', 'Group',
            'UB City', 'Orion Mall', 'PMC Chennai', 'PMC Bangalore', 'Inorbit Mall', 'L&T Metro Mall', 'VR Mall', 'Hyderabad Forum', 'Shantiniketan', 'Ecomm'
        ];
        const headerRow = worksheet.addRow(headerRowValues);

        // Styling for header row
        headerRow.eachCell((cell) => {
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFB6D7A8' } };
            cell.font = { bold: true, color: { argb: 'FF000000' } };
            cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            };
        });

        // Set column widths
        worksheet.columns = headerRowValues.map(() => ({ width: 18 }));

        // Right-aligned numeric columns
        const rightAlignColumns = [
            'Purchase Rate', 'MRP', 'GST%', 'UB City', 'Orion Mall', 'PMC Chennai', 'PMC Bangalore', 'Inorbit Mall',
            'L&T Metro Mall', 'VR Mall', 'Hyderabad Forum', 'Shantiniketan', 'Ecomm'
        ];

        // Add data rows
        filteredDataItem.forEach((rowData) => {
            const dataRow = [
                parseFloat(rowData.Code),
                rowData.Name,
                parseFloat(rowData.PurchaseRate.toFixed(2)),
                parseFloat(rowData.MRP.toFixed(2)),
                parseFloat(rowData.GSTRate),
                rowData.HSNCode,
                rowData.PG,
                rowData.IG,
                rowData.ISG,
                rowData.PF,
                rowData.CategoryName,
                rowData.ItemGroupName,
                parseFloat(rowData.UbcityQty),
                parseFloat(rowData.OrionQty),
                parseFloat(rowData.PMCChennaiQty),
                parseFloat(rowData.PMCBangaloreQty),
                parseFloat(rowData.InorbitQty),
                parseFloat(rowData.LandTQty),
                parseFloat(rowData.VRQty),
                parseFloat(rowData.HYDForumQty),
                parseFloat(rowData.ShantiniketanQty),
                parseFloat(rowData.HeadOfficeQty)
            ];

            const row = worksheet.addRow(dataRow);

            // Style each cell
            row.eachCell((cell, colNumber) => {
                const headerName = headerRowValues[colNumber - 1];
                if (rightAlignColumns.includes(headerName)) {
                    cell.alignment = { vertical: 'middle', horizontal: 'right' };
                } else {
                    cell.alignment = { vertical: 'middle', horizontal: 'center' };
                }
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' }
                };
            });
        });

        // Total row
        const totalRowValues = [
            '', 'Total', '', '', '', '', '', '', '', '', '', '',
            UbcityQty, OrionQty, PMCChennaiQty, PMCBangaloreQty, InorbitQty, LandTQty, VRQty, HYDForumQty, ShantiniketanQty, HeadOfficeQty
        ];
        const totalRow = worksheet.addRow(totalRowValues);
        totalRow.font = { bold: true };

        totalRow.eachCell((cell, colNumber) => {
            const headerName = headerRowValues[colNumber - 1];
            if (rightAlignColumns.includes(headerName)) {
                cell.alignment = { vertical: 'middle', horizontal: 'right' };
            } else {
                cell.alignment = { vertical: 'middle', horizontal: 'center' };
            }
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFF2CC' } };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            };
        });

        // Export file
        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer]), 'Stock_Transfer.xlsx');
    };


    const handlePrint = () => {

    };

    // Function to get the number of rows for a party name
    const getRowCount = (PackingListId) => {
        return filteredDataItem.filter(row => row.PackingListId === PackingListId).length;
    };

    // Function to calculate total for a specific field within a party group
    const calculateTotal = (data, BillNo, field) => {
        // Filter the data for the given party name
        const partyData = data.filter(item => item.BillNo === BillNo);

        // Calculate the total for the specified field within the party group
        return partyData.reduce((total, item) => total + item[field], 0);
    };

    const itemOptionsWithBlank = [{ label: '--Select--', value: 0 }, ...itemOptions];
    const branchOptionsWithBlank = [{ label: '--Select--', value: 0 }, ...branchOptions];

    return (
        <div className="w-full  mx-auto" style={{ width: '95%', marginTop: '10px' }}>
            <div style={{ width: '100%', marginBottom: '2', display: 'flex', flexWrap: 'nowrap', alignItems: 'center' }}>
                {/* <h5 className="block uppercase tracking-wide text-black productHead flex-grow linkcolor" style={{ flexGrow: 1, color: 'linkColor', whiteSpace: 'nowrap', marginRight: '8px' }}>Stock Transfer Report</h5> */}
                <div className='w-full mb-2 flex' style={{ marginTop: '10px' }}>
                    <h6 className="block uppercase tracking-wide text-black productHead flex-grow linkcolor" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black', width: '300px' }}>
                        Stock Transfer Report
                    </h6>
                </div>
                <div className='w-full mb-2 flex' style={{ marginTop: '10px', marginLeft: '100px' }}>
                    {loading && (
                        <div style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            zIndex: 9999
                        }}>
                            <div>
                                <CircularProgress style={{ color: 'white' }} />
                                <span style={{ color: 'white', marginTop: '10px', display: 'block' }}>Loading...</span>
                            </div>
                        </div>
                    )}


                    <Button
                        style={{ color: "black", height: '36px', marginLeft: '10px' }}
                        onClick={fetchTableData}
                        className="linkcolor"
                    >
                        <IconButton onClick={fetchTableData}>
                            <RefreshIcon style={{ color: 'brown' }} />
                        </IconButton>
                        <span style={{ color: 'brown', fontWeight: 'bolder' }}>Refresh</span>
                    </Button>


                    <Button
                        style={{ color: "black", height: '36px', marginLeft: '10px' }}
                        onClick={handleExportExcel}
                        className="linkcolor"
                    >
                        <IconButton onClick={handleExportExcel}>
                            <FeedIcon style={{ color: 'darkgreen' }} />
                        </IconButton>
                        <span style={{ color: 'darkgreen', fontWeight: 'bolder' }}>Excel</span>
                    </Button>
                    <div style={{ marginBottom: '10px', marginLeft: '20px', display: 'flex', alignItems: 'center' }}>
                        <SearchIcon onClick={toggleSearchInput} style={{ cursor: 'pointer' }} />
                        {showSearchInput && (
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="text"
                                placeholder="Search..."
                                value={searchQuery}
                                onChange={handleSearch}
                                style={{ marginLeft: '10px', width: '210px' }}
                            />
                        )}
                    </div>
                </div>

                <div className='w-full mb-2 flex' style={{ marginTop: '10px', marginLeft: '20px' }}>
                    {/* <div className="mr-2 text-white" style={{ display: 'flex', alignItems: 'center', marginTop: '30px' }}> */}
                    <RadioGroup
                        aria-label="viewOption"
                        name="viewOption"
                        value={selectedOption}
                        onChange={handleChange}
                        style={{ marginLeft: '10px', display: 'flex', flexDirection: 'row' }} // Set flexDirection to 'row'
                    >
                        <FormControlLabel value="out" control={<Radio />} className='text-black' label="Out" />
                        <FormControlLabel value="in" control={<Radio />} className='text-black' label="In" />
                    </RadioGroup>
                    {/* </div> */}
                </div>

                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                        FromDate
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date" value={fromDate} onChange={handleFromDateChange}
                        style={{ marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>
                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                        ToDate
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date" value={toDate} onChange={handleToDateChange}
                        style={{ marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>
            </div>

            <div className="watermark">
                <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
            </div>


            <div className='w-full mb-5 flex' style={{ maxHeight: '550px', overflowY: 'auto', marginTop: '7px' }}>
                <TableContainer component={Paper}>
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: '#08396B', Width: '2500px' }}>
                            <TableRow sx={{ whiteSpace: 'nowrap' }}>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>Code</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>Item</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase', textAlign: 'left' }}>Purchase Rate</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase', textAlign: 'left' }}>MRP</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase', textAlign: 'center' }}>GST%</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase', textAlign: 'center' }}>HSN Code</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase', textAlign: 'center' }}>PG</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase', textAlign: 'center' }}>IG</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase', textAlign: 'center' }}>ISG</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase', textAlign: 'center' }}>PF</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase', textAlign: 'center' }}>Category</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase', textAlign: 'center' }}>Group</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase', textAlign: 'center' }}>UB City</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase', textAlign: 'center' }}>Orion Mall</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase', textAlign: 'center' }}>PMC Chennai</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase', textAlign: 'center' }}>PMC Bangalore</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase', textAlign: 'center' }}>Inorbit Mall</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase', textAlign: 'center' }}>L&T Metro Mall</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase', textAlign: 'center' }}>VR Mall</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase', textAlign: 'center' }}>Hyderabad Forum</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase', textAlign: 'center' }}>Shantiniketan</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase', textAlign: 'center' }}>Ecomm</TableCell>
                            </TableRow>
                        </TableHead>


                        <TableBody sx={{ backgroundColor: 'whitesmoke' }}>
                            {filteredDataItem.map((data, index) => (
                                <TableRow
                                    key={data.id}
                                    className={'highlighted-row'}
                                    sx={{
                                        padding: '5px',
                                        height: '52px',

                                        backgroundColor: 'transparent',

                                    }}
                                >
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px' }}>{data.Code}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px' }}>{data.Name}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '12px' }}>{data.PurchaseRate.toFixed(2)}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '12px' }}>{data.MRP.toFixed(2)}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '12px' }}>{data.GSTRate}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '12px' }}>{data.HSNCode}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '12px' }}>{data.PG}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '12px' }}>{data.IG}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '12px' }}>{data.ISG}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '12px' }}>{data.PF}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '12px' }}>{data.CategoryName}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '12px' }}>{data.ItemGroupName}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '12px' }}>{data.UbcityQty}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '12px' }}>{data.OrionQty}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '12px' }}>{data.PMCChennaiQty}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '12px' }}>{data.PMCBangaloreQty}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '12px' }}>{data.InorbitQty}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '12px' }}>{data.LandTQty}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '12px' }}>{data.VRQty}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '12px' }}>{data.HYDForumQty}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '12px' }}>{data.ShantiniketanQty}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '12px' }}>{data.HeadOfficeQty}</TableCell>
                                </TableRow>
                            ))}

                            <TableRow
                                className={'highlighted-row'}
                                sx={{
                                    padding: '7px',
                                    height: '52px',

                                    backgroundColor: '#336D82',

                                }}
                            >
                                <TableCell colSpan={12} />
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'center' }}>{UbcityQty.toFixed(2)}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'center' }}>{OrionQty.toFixed(2)}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'center' }}>{PMCChennaiQty.toFixed(2)}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'center' }}>{PMCBangaloreQty.toFixed(2)}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'center' }}>{InorbitQty.toFixed(2)}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'center' }}>{LandTQty.toFixed(2)}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'center' }}>{VRQty.toFixed(2)}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'center' }}>{HYDForumQty.toFixed(2)}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'center' }}>{ShantiniketanQty.toFixed(2)}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'center' }}>{HeadOfficeQty.toFixed(2)}</TableCell>
                            </TableRow>

                        </TableBody>

                    </Table>
                </TableContainer>
            </div>
        </div >
    );
}

export default StockTransfer;
